import "lazysizes"

import "./src/styles/normalize.css"

import "prismjs/themes/prism-tomorrow.css"

export const onServiceWorkerUpdateReady = () => {}